import EstimateRequestDetails from "@/components/estimates/EstimateRequestDetails.vue";
import PreferredProductPriceFields from "@/components/estimates/PreferredProductPriceFields.vue";
import ProductQuoteCards from "@/components/estimates/ProductQuoteCards.vue";
import { createEstimateDetailState } from "@/controllers/estimates/detailState";
import detailPresentation from "@/controllers/estimates/detailPresentation";
import detailLifecycle from "@/controllers/estimates/detailLifecycle";
import detailDataMethods from "@/controllers/estimates/detailDataMethods";
import detailReplyMethods from "@/controllers/estimates/detailReplyMethods";

export default {
  components: {
    EstimateRequestDetails,
    PreferredProductPriceFields,
    ProductQuoteCards,
  },
  data() {
    return createEstimateDetailState();
  },
  ...detailPresentation,
  ...detailLifecycle,
  methods: {
    ...detailDataMethods,
    ...detailReplyMethods,
  },
};
